import React, { useState } from 'react'
import { Menu, Sidebar, Container, Icon, Button, Image, Segment } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import '../stylesheets/MainMenu.less'
import { MediaContextProvider, Media } from '../App.js'
import rauteLogo from '../img/Raute_logo_rgb.png'
import transformHotspotName from '../utils/helpers.js'

const MainMenu = ({ hotspots, isMobile, toggleAboutMill, activeMenuItem, aboutMillBtnActive }) => {
    const [activeItem, setActiveItem] = useState(activeMenuItem)
    const [aboutMillButtonActive, setAboutMillButtonActive] = useState(aboutMillBtnActive)
    const [sidebarOpened, setSidebarOpened] = useState(false)

    if (activeItem !== activeMenuItem)
        setActiveItem(activeMenuItem)

    if (aboutMillButtonActive !== aboutMillBtnActive)
        setAboutMillButtonActive(aboutMillBtnActive)

    const handleItemClick = (e, { name }) => {
        setActiveItem(name);
        let newViewpoint = transformHotspotName(name);
        let currentViewpoint = transformHotspotName(activeItem);

        console.log(newViewpoint, currentViewpoint);

        window.moveToViewpoint(newViewpoint, currentViewpoint);
    }
    const handleRauteClick = () => window.open("https://www.raute.com");
    const handleTalksClick = () => window.hackOpenHiddenHotspot(); //window.open("https://www.raute.com/contact");
    const handleTalkToExpertClick = () => window.open("https://www.raute.com/contact");
    const handleBookDemoClick = () => window.open("https://rauterx.hubilo.com/community/#/exhibitor");
    const handleAboutMillClick = () => {
        const toggleOpen = !aboutMillButtonActive;
        setAboutMillButtonActive(true)
        toggleAboutMill(toggleOpen)
    }
    const handleSidebarHide = () => setSidebarOpened(false)
    const handleToggle = () => setSidebarOpened(true)
    
    return (
        <MediaContextProvider>
            <Media greaterThanOrEqual="computer" className="catch-pointer-events">
                <Menu pointing secondary className="catch-pointer-events" id="main-menu">
                    <Menu.Item position='left' key='Raute logo'>
                        <Image className='custom-size-logo' size='small' src={rauteLogo}></Image>
                    </Menu.Item>
                    <Menu.Item
                        key="about-rx-mill"
                        name="about-rx-mill"
                        id={(aboutMillButtonActive) ? "about-rx-mill-active" : "about-rx-mill"}
                        active={aboutMillBtnActive}
                        onClick={handleAboutMillClick}
                    >
                        About Virtual Mill
                    </Menu.Item>
                    {
                        hotspots.map(group => (
                            <Menu.Item
                                key={group.groupName}
                                name={group.groupName}
                                className="custom-menu-item"
                                active={(aboutMillBtnActive) ? false : activeItem === transformHotspotName(group.groupName)}
                                onClick={(event) => {
                                    handleItemClick(event, {name: group.groupName});
                                    if (aboutMillButtonActive) handleAboutMillClick(event);
                                }}
                            > {group.groupName}
                            </Menu.Item>
                        ))
                    }
                    <Menu.Item 
                        key='raute-com'
                        name='raute-dot-com'
                        id='raute-dot-com'
                        onClick={handleRauteClick}
                        >Raute.com
                        <Icon name='angle right'/>
                    </Menu.Item>
                    <Menu.Item 
                        key='Talk to an Expert'
                        name='talk-to-expert'
                        id='talk-to-an-expert'
                        onClick={handleTalkToExpertClick}
                        >Talk to Raute Experts
                        <Icon name='angle right'/>
                    </Menu.Item>
                    <Menu.Item 
                        key='Expert talks'
                        name='expert-talks'
                        id='expert-talks'
                        onClick={handleTalksClick}
                        >Expert Talks
                        <Icon name='angle right'/>
                    </Menu.Item>
                </Menu>
            </Media>
            <Media as={Sidebar.Pushable} lessThan='computer' className="catch-pointer-events">
                <Sidebar
                    as={Menu}
                    direction='top'
                    animation='overlay'
                    onHide={handleSidebarHide}
                    vertical
                    pointing
                    secondary
                    visible={sidebarOpened}
                    className='catch-pointer-events'
                    id="main-menu"
                    >
                        <Menu.Item
                            key='Close menu'
                            onClick={handleSidebarHide}
                        >
                            <Button.Content>
                                <Image size='tiny' src={rauteLogo}></Image>
                            </Button.Content>
                            <Button.Content style={{ "textAlign": "right", "marginTop": "-12px" }}>
                                <Icon name='close'/>
                            </Button.Content>
                        </Menu.Item>
                        {
                            hotspots.map(group => (
                                <Menu.Item
                                    key={group.groupName}
                                    name={group.groupName}
                                    active={(aboutMillBtnActive) ? false : activeItem === transformHotspotName(group.groupName)}
                                    onClick={(event) => {
                                        handleItemClick(event, {name: group.groupName});
                                        handleSidebarHide(event);
                                        if (aboutMillButtonActive) handleAboutMillClick(event);
                                    }}
                                    > {group.groupName}
                                </Menu.Item>
                            ))
                        }
                        <Menu.Item
                            key="about-rx-mill"
                            name="about-rx-mill"
                            id={(aboutMillButtonActive) ? "about-rx-mill-active" : "about-rx-mill"}
                            active={aboutMillBtnActive}
                            onClick={(event) => {
                                handleAboutMillClick(event);
                                handleSidebarHide(event);
                            }}>
                            About Virtual Mill
                        </Menu.Item>
                        <br/>
                        <Menu.Item 
                            key='raute-com'
                            name='raute-dot-com'
                            id='raute-dot-com'
                            onClick={handleRauteClick}
                            >Raute.com
                            <Icon name='angle right'/>
                        </Menu.Item>
                        <Menu.Item 
                            key='Talk to an Expert'
                            name='talk-to-expert'
                            id='talk-to-an-expert'
                            onClick={handleTalkToExpertClick}
                            >Talk to Raute Experts
                            <Icon name='angle right'/>
                        </Menu.Item>
                        <Menu.Item 
                            key='Expert talks'
                            name='expert-talks'
                            id='expert-talks'
                            onClick={handleTalksClick}
                            >Expert Talks
                        <Icon name='angle right'/>
                    </Menu.Item>
                        <br/>
                </Sidebar>
                <Sidebar.Pusher dimmed={sidebarOpened} className='mobile-menu-pusher'>
                    <Menu 
                        pointing 
                        secondary 
                        size='small'
                        className='catch-pointer-events'
                    >
                        <Menu.Menu position='left'>
                            <Menu.Item key='Raute logo'>
                                <Image className='custom-size-logo' size='small' src={rauteLogo}></Image>
                            </Menu.Item>
                        </Menu.Menu>
                        <Menu.Item position='right' onClick={handleToggle}>
                            <Icon size='big' name='sidebar' />
                        </Menu.Item>
                    </Menu>
                </Sidebar.Pusher>
            </Media>
        </MediaContextProvider>
    )
}

MainMenu.propTypes = {
    hotspots: PropTypes.array,
    isMobile: PropTypes.bool,
    toggleOpen: PropTypes.func,
    activeMenuItem: PropTypes.string
}


export default MainMenu;